package dev.kuml.portal.web.i18n.strings

public interface ActivityStrings {
    public val sectionTitle: String
    public val loading: String
    public val loadFailed: String
    public val legendLess: String
    public val legendMore: String

    /** Plural-correct summary line, e.g. `"3 diagrams · current streak of 2 days"` -- fixes the
     * pre-R-18 `"Diagramm(e) · aktuelle Serie N Tag(e)"` placeholder-style wording (this wave's
     * plan, decision E-12). */
    public fun summary(
        total: Long,
        streakDays: Long,
    ): String

    public fun tooltipNone(date: String): String

    public fun tooltipOne(date: String): String

    public fun tooltipMany(
        count: Long,
        date: String,
    ): String

    public val allPlainStrings: List<String>
        get() = listOf(sectionTitle, loading, loadFailed, legendLess, legendMore)
}

public object ActivityStringsDe : ActivityStrings {
    override val sectionTitle = "Ihre Aktivität"
    override val loading = "Aktivität wird geladen …"
    override val loadFailed = "Aktivität konnte nicht geladen werden."
    override val legendLess = "Weniger"
    override val legendMore = "Mehr"

    override fun summary(
        total: Long,
        streakDays: Long,
    ): String {
        val diagrams = if (total == 1L) "1 Diagramm" else "$total Diagramme"
        val streak = if (streakDays == 1L) "1 Tag" else "$streakDays Tage"
        return "$diagrams · aktuelle Serie $streak"
    }

    override fun tooltipNone(date: String): String = "Keine Diagramme am $date"

    override fun tooltipOne(date: String): String = "1 Diagramm am $date"

    override fun tooltipMany(
        count: Long,
        date: String,
    ): String = "$count Diagramme am $date"
}

public object ActivityStringsEn : ActivityStrings {
    override val sectionTitle = "Your activity"
    override val loading = "Loading activity …"
    override val loadFailed = "Activity could not be loaded."
    override val legendLess = "Less"
    override val legendMore = "More"

    override fun summary(
        total: Long,
        streakDays: Long,
    ): String {
        val diagrams = if (total == 1L) "1 diagram" else "$total diagrams"
        val streak = if (streakDays == 1L) "1 day" else "$streakDays days"
        return "$diagrams · current streak of $streak"
    }

    override fun tooltipNone(date: String): String = "No diagrams on $date"

    override fun tooltipOne(date: String): String = "1 diagram on $date"

    override fun tooltipMany(
        count: Long,
        date: String,
    ): String = "$count diagrams on $date"
}
